/* eslint-disable react/jsx-props-no-spreading */
import MicromagConsent from '@micromag/consent';
import classNames from 'classnames';
import React, { useEffect, useCallback, useRef } from 'react';

import useKeyboardKeys, { KEYS } from '../../hooks/useKeyboardKeys';

import { useModal } from '../../contexts/ModalContext';

import styles from '../../styles/modals/consent.module.css';

function Consent({ className = null }: { className?: string | null }) {
    const modalRef = useRef(null);
    const { modal = null, setModal, unsetModal } = useModal();

    const onClose = useCallback(() => {
        unsetModal();
        setModal(null);
    }, [setModal]);

    const visible = modal !== null;

    useEffect(() => {
        if (modal !== null) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [modal]);

    useKeyboardKeys({
        [KEYS.ESCAPE]: onClose,
    });

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.visible]: visible,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.wrapper} ref={modalRef}>
                <div className={styles.inner}>
                    <MicromagConsent
                        className={styles.consent}
                        onConfirm={onClose}
                        onClose={onClose}
                        labels={{
                            title: 'Gestion des cookies',
                            description:
                                "Ce site utilise des cookies techniques et des cookies de mesure d'audience visant à vous offrir un bon fonctionnement et une meilleure expérience utilisateur.",
                            terms: 'Lire notre politique de gestion des cookies',
                        }}
                    />
                </div>
            </div>
            <div className={styles.lightBox} />
        </div>
    );
}

export default Consent;
